<template>
  <div class="vx-col w-full">
    <vx-card title="Guarantor Occupation Information">
      <br>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Occupation Type</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio v-model="occupation.occupationType" vs-value="Employed">Employed</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="occupation.occupationType" vs-value="Self-Employed">Self-Employed</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="occupation.occupationType" vs-value="Unemployed">Unemployed</vs-radio>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="occupation.occupationType !== 'Unemployed'" class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Organization Type</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <v-select label="occuName" v-model="occupation.occupationName" class="w-full select-large"
                          :options="occupationDrop" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Monthly Income In BDT</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="number" v-model="occupation.monthlyIncome"/>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Name of the Office/Business </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="occupation.officeOrBusinessNm"/>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Designation</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="occupation.designation"/>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Job length</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <div class="demo-alignment">
                <vs-input class="mt-0"  type="text" v-model="occupation.year" placeholder="Year"/>
                <template>
                  <v-select v-model="occupation.month" class="select-large mt-0" style="width:120px" placeholder="Months" :options="jobLengthArr"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!--<div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Job length</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <div class="demo-alignment">
                &lt;!&ndash;                    <datepicker placeholder="Select Date" v-model="occupation.jobLength"></datepicker>&ndash;&gt;
                <vs-input class="mt-0"  type="text" v-model="occupation.year" placeholder="Year"/>
                <vs-input class="mt-0"  type="text" v-model="occupation.month" placeholder="Months"/>
              </div>
            </div>
          </div>
        </div>-->
      </div>
      <div class="vx-row">
        <vx-card title="Occupation Address">
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Division</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <template>
                    <v-select label="name" v-model="occupation.occDivision" class="w-full select-large"
                              :options="divisionJson"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="occupation.occDivision" class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>District</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <template>
                    <v-select label="name" v-model="occupation.occDistrict" class="w-full select-large"
                              :options="districtJson.filter(occuDist => occuDist.division_id === occupation.occDivision.id)"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div v-if="occupation.occDistrict" class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Thana</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <template>
                    <v-select label="name" v-model="occupation.occThana" class="w-full select-large"
                              :options="thanas.filter(occThana => occThana.district_id === occupation.occDistrict.id)"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="occupation.occThana" class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Office Area</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" type="text" v-model="occupation.officeArea"/>
                </div>
              </div>
            </div>
          </div>
          <div v-if="occupation.officeArea" class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Apt#/House#/Road#/Village# </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" type="text" v-model="occupation.ofcAptHouseRoadVill"/>
                </div>
              </div>
            </div>
            <div v-if="occupation.ofcAptHouseRoadVill" class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Postal code</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" type="text" v-validate="'required|min:4|max:4'" data-vv-as="Postal code"
                            name="occupation.ofcPostalCode"  v-model="occupation.ofcPostalCode"/>
                  <span class="text-danger text-sm" v-show="errors.has('occupation.ofcPostalCode')">{{ errors.first('occupation.ofcPostalCode') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-button color="success" class="mr-3 mb-2 float-right" @click="updateOccupationInfo">Update
              </vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </vx-card>
  </div>
</template>
<script>



  import guarantorOccupationUpdate from '../graphql/GuarantorOccuUpdate.gql'
  import division from '../assets/utils/division'
  import district from '../assets/utils/district'
  import upazila from '../assets/utils/upazila'
  import {ME} from '../graphql/userinfo'
  import {onLogin} from '../vue-apollo'
  //import {FormWizard, TabContent} from 'vue-form-wizard'
  //import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import vSelect from 'vue-select'
  import Datepicker from 'vuejs-datepicker'
  import gql from 'graphql-tag'

  export default {
    data () {
      return {
        divisionJson: division.divisions,
        districtJson: district.districts,
        thanas: upazila.upazilas,
        userInfo: '',
        occupation: {
          occupationType: '',
          occupationName: '',
          monthlyIncome: '',
          officeOrBusinessNm: '',
          designation: '',
          year:'0',
          month:'0',
          jobLength: '',
          occDivision: '',
          occDistrict: '',
          occThana: '',
          officeArea: '',
          ofcAptHouseRoadVill: '',
          ofcPostalCode: ''
        },
        dependantDrop: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12],
        jobLengthArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        occupationDrop: ['Agricultural Firm', 'Audit Farm', 'Bank/Financial Organization', 'Consultancy Farm','Development/ Construction Farm', 'Educational Institution', 'Foreign Organization','Freelancer', 'Government Organization','Hospital/Health Care Organization','Hotel and Restaurant','Manufacturing Company','Multinational Company','Non-Government Organzation','Private Organization','Proprietorship Company','Public Limited Company','Telecom Industry','Tourism Industry','Other']
      }
    },
    apollo: {
      guarantor: {
        query: gql`
         query guarantor($id: ID!){
          guarantor(id:$id){
            id
            name
            phone
            email
            relationship
            status
            ekyc {
              id
              phone
              nid
              email
              status
                occupation {
                id
                occupation_type
                occupation
                monthly_income
                name_of_Office_or_business
                designation
                job_length
                occupationAddress {
                  id
                  division
                  district
                  thana
                  office_area
                  address
                  postal_code
                }
              }
            }
          }
         }
         `,
        variables () {
          return {
            id: this.$route.params.guarantorId
          }
        },
        update: (data) => data.guarantor
      }

    },
    watch: {
      guarantor (value) {
        this.guarantor = value;

        if(value.ekyc !== null){
          this.userInfo = value;
          console.log('GuarantorByIDOcccc : =', this.userInfo);
          if(value.ekyc.occupation !==null){
            if(this.userInfo.ekyc.occupation !== null){
              this.occupation.occupationType = this.userInfo.ekyc.occupation.occupation_type
              this.occupation.occupationName = this.userInfo.ekyc.occupation.occupation
              this.occupation.monthlyIncome = this.userInfo.ekyc.occupation.monthly_income
              this.occupation.officeOrBusinessNm = this.userInfo.ekyc.occupation.name_of_Office_or_business
              this.occupation.designation = this.userInfo.ekyc.occupation.designation
                var ar = this.userInfo.ekyc.occupation.job_length.split(',');
                console.log('Arrrray', ar)
                this.occupation.year = ar[0]
                this.occupation.month = ar[1]
              //this.occupation.jobLength = this.userInfo.ekyc.occupation.job_length
              this.occupation.occDivision = this.userInfo.ekyc.occupation.occupationAddress.division
              this.occupation.occDistrict = this.userInfo.ekyc.occupation.occupationAddress.district
              this.occupation.occThana = this.userInfo.ekyc.occupation.occupationAddress.thana
              this.occupation.officeArea = this.userInfo.ekyc.occupation.occupationAddress.office_area
              this.occupation.ofcAptHouseRoadVill = this.userInfo.ekyc.occupation.occupationAddress.address
              this.occupation.ofcPostalCode = this.userInfo.ekyc.occupation.occupationAddress.postal_code
            }
          }
        }
      }
    },
    methods: {

      async updateOccupationInfo () {
        console.log("UpdateOccu",this.occupation)
        await this.$apollo.mutate({
          mutation: guarantorOccupationUpdate,
          variables: {
            ekyc_id: this.$route.params.ekycId,
            occupation_type: this.occupation.occupationType,
            occupation: this.occupation.occupationName || '',
            monthly_income: this.occupation.monthlyIncome,
            name_of_Office_or_business: this.occupation.officeOrBusinessNm,
            designation: this.occupation.designation,
            job_length: this.occupation.year+','+ this.occupation.month,
            division: this.occupation.occDivision ===null? "": this.occupation.occDivision.name,
            district: this.occupation.occDistrict ===null? "": this.occupation.occDistrict.name,
            thana: this.occupation.occThana ===null? "": this.occupation.occThana.name,
            office_area: this.occupation.officeArea ===null? "": this.occupation.officeArea,
            address: this.occupation.ofcAptHouseRoadVill ===null? "": this.occupation.ofcAptHouseRoadVill,
            postal_code: this.occupation.ofcPostalCode ===null? "": this.occupation.ofcPostalCode
          }
        }).then((data) => {
          console.log('Data = ', data);
          this.$router.push('/applicationDetails/'+ this.$route.params.purchaseId).catch(() => {});
          this.$vs.notify({
            title: 'Updated',
            text: 'Occupation Information Successfully Updated.',
            color: "success",
            position: 'top-right'
          })
          this.contactTab = true
          console.log('this.contactTab = ', this.contactTab)
        }).catch((error) => {
          console.log("Contact Error", error);
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: "danger",
            position: 'top-right'
          });
        })
      },
    },
    components: {
      //FormWizard,
      //TabContent,
      'v-select': vSelect,
      Datepicker
    }
  }
</script>
